const DEFAULT_HASH_SEED = 5381;
const MAX_HASH_INT = 0x7fffffff;
const HASH_MULTIPLIER = 33;

// A utility to create a hash value for an object. Keys are
// are sorted to ensure deterministic results regardless of key order.
export const hashObject = (value: unknown, seed = DEFAULT_HASH_SEED): number => {
	if (value !== null && typeof value === 'object') {
		if (Array.isArray(value)) {
			return value.reduce((acc, item) => hashObject(item, acc), seed);
		} else {
			const keys = Object.keys(value).sort((a, b) => a.localeCompare(b));
			return keys.reduce((acc, key) => {
				return hashObject(value[key], hashString(acc, key));
			}, seed);
		}
	}

	// number, string, boolean
	return hashString(seed, String(value));
};

// hash string using djb2 algorithm
const hashString = (seed: number, str: string): number =>
	[...str].reduce((hash, ch) => (hash * HASH_MULTIPLIER + ch.charCodeAt(0)) % MAX_HASH_INT, seed);
